exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".transaction-card{margin-left:0;margin-right:0;margin-top:60px}.transaction-card .card{margin:0}", ""]);

